// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__20o_6","tab":"ProcedureTabs_tab__2nWLg"};